import { getDistList } from "@/api/clueNew";

/**
 * 获取字典值
 * @param {string} code 字典编码
 * @returns {Promise} 返回字典值列表
 */
export function getDictionaryByCode(code) {
  return getDistList(code)
    .then(response => {
      return response || [];
    })
    .catch(error => {
      console.error("获取字典数据失败:", error);
      return [];
    });
}
